import { render, staticRenderFns } from "./type100.vue?vue&type=template&id=7196397c&scoped=true"
import script from "./type100.vue?vue&type=script&lang=js"
export * from "./type100.vue?vue&type=script&lang=js"
import style0 from "./type100.vue?vue&type=style&index=0&id=7196397c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7196397c",
  null
  
)

export default component.exports